<template>
  <div class="head-tip-man" :style="data.headTipStyle">
    <img
      class="head"
      v-if="data.headTipImg"
      :src="'//cdn.original-fun.com/gugong/' + data.headTipImg + '.png'"
    />
    <div class="bg" v-if="data.headTipTxt">
      <div class="txt">
        <div class="flower" v-if="data.flower"></div>
        {{ data.headTipTxt }}
      </div>
    </div>
    <div class="next-word" @click="jump">{{ data.headTipPathTxt }}</div>
  </div>
</template>

<script>
//script
import Tools from "../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../scripts/Global";

export default {
  props: ["data"],

  data() {
    return {};
  },
  components: {},
  created() {
    console.log("headTip", this.data);
  },
  computed: {},
  methods: {
    jump() {
      console.log("headTip emit jump");
      this.$emit("jump");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.head-tip-man {
  width: 6.5rem;
  height: 1.5rem;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  margin-left: -3.25rem;
  bottom: 0;
  
  .head {
    position: absolute;
    width: 2rem;
    bottom: 0.2rem;
    right: 0;
  }
  .bg {
    background-image: url(//cdn.original-fun.com/gugong/答错提示框.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 1.5rem;
    width: 100%;
    bottom: 0;
    line-height: 1.5rem;
    color: #fff;
    position: absolute;
    .txt {
      margin: 0 0.8rem 0 0.8rem;
      line-height: 0.4rem;
      position: relative;
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .flower {
        width: 1rem;
        height: 1rem;
        background-image: url(//cdn.original-fun.com/gugong/单朵太平花.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        transform: scale(0.8);
        left: 50%;
        margin-left: -0.5rem;
        top: -0.5rem;
      }
      // word-break: keep-all;
    }
  }

  .next-word {
    position: absolute;
    right: 0;
    bottom: -0.5rem;
    font-weight: bold;
  }
}
</style>
